'use client';

import { FC } from 'react';
import { Container, Wrapper } from '@/features/pages/home';
import { Typography } from '@mui/material';
import { COLORS } from '@/constants';
import { IHousingObjectResponse } from '@/types';
import { BgFigure, CenteredHead, GridList } from './styled';

import discountBgFigure from '@/assets/webp/discounted-bg-form.webp';

import { HousingCard } from '@/components';
import { useTranslations } from 'next-intl';

type DiscountedProps = {
  data?: IHousingObjectResponse[];
};

export const Discounted: FC<DiscountedProps> = ({ data }) => {
  const t = useTranslations();
  return (
    <Wrapper $bgColor="blue">
      <Container>
        <CenteredHead>
          <Typography
            fontSize={{ xs: 26, sm: 26, md: 34 }}
            lineHeight={1}
            fontWeight={700}
            color={COLORS.white}
          >
            {t('discountProperties.title')}
          </Typography>
          <Typography
            fontSize={18}
            lineHeight={1.26}
            fontWeight={600}
            color={COLORS['beige-silver']}
          >
            {t('discountProperties.desc')}
          </Typography>
        </CenteredHead>
        <GridList>
          {data?.map((e, i) => (
            <HousingCard data={e} key={i} isProject={false} />
          ))}
        </GridList>
      </Container>
      <BgFigure>
        <img src={discountBgFigure.src} alt="background-decoration" />
      </BgFigure>
    </Wrapper>
  );
};
